export default "__VITE_ASSET__BcF7UX3j__"